import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderCrossPromoVkMusicFakedoorModalThanks = () => {
    openPopupHelper({
        popupName: popupNames.CROSS_PROMO_VK_MUSIC_FAKEDOOR_MODAL_THANKS,
    });
};
